import React, { PureComponent } from 'react';
import { Translate, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { firebaseConnect, getVal, isEmpty } from 'react-redux-firebase';
import { compose } from 'redux';
import styled from 'styled-components';

import Indicator from '../../components/indicator';
import TitledSection from '../../components/titled-section';
import withDatabase from '../../hocs/with-database';
import Order from '../order';
import locale from './locale.js';

const MaxWidthContainer = styled.div`
  max-width: 30em;
  margin: 0 auto;
  padding: 0 1em;
`;

/**
 * Displays all user orders
 */
class OrdersPage extends PureComponent {
  constructor(props) {
    super(props);
    this.props.addTranslation(locale);
  }

  render() {
    const { games, orders, requesting } = this.props;
    const areOrders = !isEmpty(orders);
    return (
      <TitledSection subtitleId="orders.description" titleId="orders.title">
        <MaxWidthContainer>
          {requesting ? (
            <Indicator spin />
          ) : (
            <>
              {!areOrders && <Translate id="orders.none" />}
              {areOrders &&
                Object.keys(orders)
                  .reverse()
                  .filter(key => !orders[key].error)
                  .map(orderId => {
                    const order = orders[orderId];
                    const game = games && games[order.gameId];
                    return (
                      <Order
                        game={game}
                        key={orderId}
                        order={order}
                        orderId={orderId}
                      />
                    );
                  })}
            </>
          )}
        </MaxWidthContainer>
      </TitledSection>
    );
  }
}

/**
 * Map Redux State to props
 //  */
const mapStateToProps = ({ auth, firebase }) => {
  const uid = auth.user.uid;
  return {
    orders: getVal(firebase.data, `/orders/${uid}`) || {},
    games: getVal(firebase.data, '/games'),
    uid,
    requesting: Object.entries(firebase.requesting).some(
      ([key, val]) => key.startsWith('orders') && val
    )
  };
};

export default compose(
  withDatabase,
  withLocalize,
  connect(mapStateToProps, null),
  firebaseConnect(({ uid }) => {
    return [
      '/games',
      {
        path: `/orders/${uid}`,
        queryParams: ['orderByChild=createdAt']
      }
    ];
  })
)(OrdersPage);
